<template>
    <div class="mt-5">
        <h3>{{ $t("overviews.productionOverview") }}</h3>
        <div class="row align-items-center mb-2 mt-4">
            <div class="col-2">
                <button @click="setProductionLastWeek()" class="btn button-top">{{ $t("overviews.lastWeek") }}</button>
            </div>
            <div class="col-2">
                <button @click="setProductionLastMonth()" class="btn button-top">{{ $t("overviews.lastMonth") }}</button>
            </div>
            <div class="col-2">
                <button @click="setProductionLastYear()" class="btn button-top">{{ $t("overviews.lastYear") }}</button>
            </div>
            <div class="col-2">
                <button @click="setProductionActualMonth()" class="btn button-top">{{ $t("overviews.actualMonth")
                }}</button>
            </div>
        </div>
        <div class="row mb-1 align-items-center">
            <div class="col-2">
                <label class="control-label">{{ $t("overviews.from") }}</label>
            </div>
            <div class="col-2">
                <label class="control-label">{{ $t("overviews.to") }}</label>
            </div>
            <div class="col-4 col-lg-2">
                <label class="control-label">{{ $t("overviews.warehouse") }}</label>
            </div>
            <div class="col-4 ">
                <label class="control-label">{{ $t("overviews.finishedOrders") }}</label>
            </div>
        </div>
        <div class="row align-items-center mb-3">
            <div class="col-2">
                <input type="date" v-model="fromProduction" :max="toProduction" class="form-control" />
            </div>
            <div class="col-2">
                <input type="date" v-model="toProduction" :min="fromProduction" class="form-control" />
            </div>
            <div class="col-4 col-lg-2">
                <select v-model="product_warehouse" style="width: 100%" class="form-select">
                    <option :value="null">{{ $t("overviews.all") }}</option>
                    <option v-for="warehouse in warehouses" :value="warehouse.id" :key="warehouse.id">{{ warehouse.name }}
                    </option>
                </select>
            </div>

            <div class="col-4">
                <input type="checkbox" v-model="products_done" class="form-check-input">
            </div>
        </div>
        <div class="row">
            <div id="count_production_chart_div" style="width: 100%; height: 450px;" class="mb-2"></div>
            <div id="CZK_production_chart_div" style="width: 100%; height: 450px;" class="mb-2"></div>
            <div id="EUR_production_chart_div" style="width: 100%; height: 450px;" class="mb-2"></div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        warehouses: {
            type: Array,
            required: false,
            default: []
        },
    },
    data() {
        return {
            fromProduction: null,
            toProduction: null,
            product_warehouse: null,
            products: [],
            products_done: true,
        }
    },
    watch: {
        toProduction: function () {
            this.getProductionStats()
        },
        fromProduction: function () {
            this.getProductionStats()
        },
        product_warehouse: function (value) {
            if (value == "null") {
                this.product_warehouse = null;
            }
            this.getProductionStats()
        },
        products_done: function () {
            this.getProductionStats()
        },
    },
    created: function () {
        this.toProduction = this.getDateFormatted(new Date());
        var from = new Date();
        from.setMonth(from.getMonth() - 1);
        this.fromProduction = this.getDateFormatted(from);
        this.getProductionStats();
    },
    methods: {
        getDateFormatted: function (date) {
            return date.getFullYear() + "-" + (date.getMonth() + 1).toString().padStart(2, '0') + "-" + date.getDate().toString().padStart(2, '0');
        },
        getProductionStats: function () {
            this.$store.getters.api.get('/stats_for_products', { params: { to: this.toProduction, from: this.fromProduction, warehouse: this.product_warehouse, done: this.products_done } }).then(function (response) {
                this.products = response.data.data;
                this.draw(this.drawProductionCountChart);
                this.draw(this.drawProductsChartEUR);
                this.draw(this.drawProductsChartCZK);
            }.bind(this));
        },
        draw: function (fn, language) {
            google.charts.load("current", { packages: ["corechart"], 'language': "cs" });
            google.charts.setOnLoadCallback(fn);
        },
        drawWarehousesChartCZK: function () {
            this.drawWarehousesChart("CZK");
        },
        drawWarehousesChartEUR: function () {
            this.drawWarehousesChart("EUR");
        },
        drawProductsChartEUR: function () {
            this.drawProductsChart("EUR");
        },
        drawProductsChartCZK: function () {
            this.drawProductsChart("CZK");
        },
        drawWarehousesChart: function (currency) {
            var array = [["Sklad", "Hodnota", { role: 'style' }]]
            for (var i = 0; i < this.warehouses.length; i++) {
                array.push([this.warehouses[i].name, this.warehouses[i].prices[currency], this.warehouses[i].color])
            }
            var data = google.visualization.arrayToDataTable(array);

            var suffix = ((currency == "CZK") ? ' Kč' : ' Eur');

            var options = {
                title: 'Hodnota zakázek pro dané sklady v ' + currency,
                backgroundColor: {
                    fill: '#FFFFFF',
                    fillOpacity: 0.5
                },
                legend: { position: "none" },
                titleTextStyle: {
                    fontSize: 18
                }
            };

            var formatter = new google.visualization.NumberFormat(
                { suffix: suffix });
            formatter.format(data, 1);

            var chart = new google.visualization.ColumnChart(document.getElementById(currency + '_warehouses_chart_div'));
            chart.draw(data, options);
        },
        drawWarehousesCountChart: function () {
            var array = [["Sklad", "Počet", { role: 'style' }]]
            for (var i = 0; i < this.warehouses.length; i++) {
                array.push([this.warehouses[i].name, this.warehouses[i].count, this.warehouses[i].color])
            }
            var data = google.visualization.arrayToDataTable(array);

            var options = {
                title: 'Počet zakázek pro dané sklady',
                backgroundColor: {
                    fill: '#FFFFFF',
                    fillOpacity: 0.5
                },
                legend: { position: "none" },
                titleTextStyle: {
                    fontSize: 18
                }
            };

            var chart = new google.visualization.ColumnChart(document.getElementById('count_warehouses_chart_div'));
            chart.draw(data, options);
        },
        drawProductsChart: function (currency) {
            var array = [["Product", "Hodnota"]]
            for (var i = 0; i < this.products.length; i++) {
                array.push([this.products[i].name, this.products[i].prices[currency]])
            }
            var data = google.visualization.arrayToDataTable(array);

            var suffix = ((currency == "CZK") ? ' Kč' : ' Eur');

            var options = {
                title: 'Hodnota objednávek daných produktů v ' + currency,
                backgroundColor: {
                    fill: '#FFFFFF',
                    fillOpacity: 0.5
                },
                legend: { position: "none" },
                titleTextStyle: {
                    fontSize: 18
                }
            };

            var formatter = new google.visualization.NumberFormat(
                { suffix: suffix });
            formatter.format(data, 1);

            var chart = new google.visualization.ColumnChart(document.getElementById(currency + '_production_chart_div'));
            chart.draw(data, options);
        },
        drawProductionCountChart: function () {
            var array = [["Product", "Počet", { type: 'string', role: 'tooltip', p: { 'html': true } }]]
            for (var i = 0; i < this.products.length; i++) {
                var tooltip = "<span style='font-size: 14px;'><b>" + this.products[i].name + "</b><br>";
                tooltip += "Počet: <b>" + this.products[i].count + " " + this.products[i].measurement_unit + "</b></span>";
                array.push([this.products[i].name, this.products[i].count, tooltip])
            }
            var data = google.visualization.arrayToDataTable(array);

            var options = {
                tooltip: { isHtml: true },
                title: 'Počet kusů dle produktů',
                backgroundColor: {
                    fill: '#FFFFFF',
                    fillOpacity: 0.5
                },
                legend: { position: "none" },
                titleTextStyle: {
                    fontSize: 18
                }
            };

            var chart = new google.visualization.ColumnChart(document.getElementById('count_production_chart_div'));
            chart.draw(data, options);
        },
        setProductionLastWeek: function () {
            var to = new Date()
            to.setDate(to.getDate() - to.getDay());
            this.toProduction = this.getDateFormatted(to);
            var from = new Date();
            from.setDate(from.getDate() - 6 - from.getDay());
            this.fromProduction = this.getDateFormatted(from);
            this.getProductionStats();
        },
        setProductionLastMonth: function () {
            var to = new Date();
            to.setMonth(to.getMonth());
            to.setDate(0);
            var from = new Date();
            from.setMonth(from.getMonth() - 1);
            from.setDate(1);
            this.toProduction = this.getDateFormatted(to);
            this.fromProduction = this.getDateFormatted(from);
            this.getProductionStats();
        },
        setProductionLastYear: function () {
            var to = new Date();
            to.setFullYear(to.getFullYear() - 1);
            to.setMonth(12);
            to.setDate(0);
            var from = new Date();
            from.setFullYear(from.getFullYear() - 1);
            from.setMonth(0);
            from.setDate(1);
            this.toProduction = this.getDateFormatted(to);
            this.fromProduction = this.getDateFormatted(from);
            this.getProductionStats();
        },
        setProductionActualMonth: function () {
            var to = new Date();
            to.setMonth(to.getMonth() + 1);
            to.setDate(0);
            this.toProduction = this.getDateFormatted(to);
            var from = new Date();
            from.setDate(1);
            this.fromProduction = this.getDateFormatted(from);
            this.getProductionStats();
        }
    }
}
</script>
<style scoped lang="scss">
@media (min-width: 992px) {
  .col-lg-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
}
</style>